export default "__VITE_ASSET__D56s1yML__"